import { Box, Card, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, TextField, Tabs, Tab, InputAdornment, Button } from '@mui/material';
import LayoutAccessManagement from 'components/structure/LayoutAccessManagement';
import { useState } from 'react';
import editPencil from 'assets/user-access/editPencil.svg'
import leftIcon from 'assets/user-access/leftIcon.svg'
import { useNavigate } from 'react-router-dom';
import CustomBlueCheckbox from 'utils/CustomBlueCheckbox';


const RoleAssignModuleEdit = () => {
    const navigate = useNavigate();

    const columns = [
        { id: 'module', label: 'Module' },
        { id: 'action', label: 'Action' },
        { id: 'flf', label: 'Field Level Filter' },
    ];

    const [data, setdata] = useState(
        [{
            modules: { id: 1, moduleName: 'Contracting', canCreate: false, canEdit: true, canUpdate: true, canDelete: true },
            subModules: [
                { id: 1, moduleName: 'Farmer Registration', canCreate: true, canEdit: false, canUpdate: true, canDelete: true },
                { id: 2, moduleName: 'Survey', canCreate: false, canEdit: true, canUpdate: true, canDelete: false }

            ],
        },

        {
            modules: { id: 1, moduleName: 'Only Reports', canCreate: false, canEdit: true, canUpdate: true, canDelete: true },
            subModules: [
            ],
        }],

    )

    const VerticalLine = () => {
        return (
            < Box
                sx={{
                    width: '100%',
                    height: '2px',
                    backgroundColor: '#0E2B63',
                    opacity: 0.2,
                    margin: '0 auto'
                }}
            />
        );
    };
    const handleToggle = (id, field, value) => {
     
    };

    const onEdit = (row) => {

        navigate('/roleAssign/editSubmodule/' + row?.modules?.id)
    }
    return (
        <LayoutAccessManagement title="Access Management">
            <Card
                className='Access-Management-Layout'
                sx={{
                    backgroundColor: "#f3f5f8",
                    color: "white",
                    marginBottom: "30px",
                    padding: "20px",
                    border: "none",
                    boxShadow: "0px 0px 10px 0px rgba(0, 0, 0, 0.1)",
                    display: "flex",
                    justifyContent: "center"
                }}
            >
                <Box sx={{ width: "948px", marginTop: "40px", marginBottom: "40px", borderRadius: '16px', backgroundColor: "#fff", height: "auto" }}>
                    <Box className="roleAssignHeader">
                        Survey Approver
                    </Box>
                    <VerticalLine />
                    <Box className="roleAssignHeader2" sx={{ fontWeight: 700, padding: '23px 0px 20px 0px' }}>
                        Role Owner
                        <Box className="roleAssignHeader2" sx={{ fontWeight: 500 }}>Local ESG Admin</Box>
                    </Box>
                    <VerticalLine />
                    <Box className="roleAssignHeader2" sx={{ fontWeight: 700, padding: '20px 0px 17px 0px' }}>Assigned Functionality</Box>
                    <Box className="roleAssignTable">
                        <TableContainer component={Paper} sx={{ overflow: 'unset !important' }}>
                            <Table>
                                <TableHead sx={{ backgroundColor: '#102A63' }}>
                                    <TableRow>
                                        {columns?.map((column, index) => (
                                            <>
                                                {column?.id == 'module' ?
                                                    <TableCell
                                                        sx={{ color: '#fff', display:"flex",alignItems:"center", borderRight: '1px solid #ddd', textAlign: "left" }}
                                                        key={column.id}>
                                                            <img onClick= {()=>navigate(-1)} src={leftIcon} style={{paddingRight:"12px" ,cursor:"pointer" }}/>
                                                        {column.label}
                                                    </TableCell>
                                                    : <TableCell
                                                        sx={{ color: '#fff', borderRight: '1px solid #ddd', textAlign: "center" }}
                                                        key={column.id}>
                                                        {column.label}
                                                    </TableCell>}

                                            </>

                                        ))}
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {data.map((row, ind) => (
                                        <>
                                            <TableRow key={ind}>
                                                <TableCell sx={{
                                                    borderRight: '1px solid #ddd',
                                                    wordBreak: 'break-word',
                                                    overflowWrap: 'break-word',
                                                    maxWidth: 300,
                                                    minWidth: 200,
                                                }}><Box className="roleAssignTableSubModule">{row?.modules?.moduleName}</Box></TableCell>
                                                <TableCell sx={{ borderRight: '1px solid #ddd', textAlign: "center",width:"52px"}}>
                                                    <CustomBlueCheckbox
                                                        checked={row?.modules?.canCreate}
                                                        onClick={() => handleToggle(row?.modules?.canCreate, 'module')}
                                                    />
                                                </TableCell>
                                                <TableCell sx={{ borderRight: '1px solid #ddd', textAlign: "center",width:"122px"}}>
                                                    <img style={{ cursor: "pointer" }} src={editPencil} 
                                                            onClick={() => onEdit(row, 'module')}
                                                    />
                                                </TableCell>

                                            </TableRow>
                                        </>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Box>
                    <Box sx={{ paddingTop: "30px" }}>
                        <VerticalLine />
                    </Box>
                    <Box sx={{ display: "flex", justifyContent: "center", alignItems: "cemter", margin: "40px 10px" }}>
                        <Button
                            sx={{
                                justifyContent: "center",
                                borderRadius: 4,
                                minWidth: 130,
                                minHeight: 54,
                                background: "#737D86",
                                marginLeft: "20px",
                                "&:hover": {
                                    backgroundColor: "#737D86",
                                },
                            }}
                            variant="contained"
                            type="button"
                            onClick={(e) => navigate(-1)}
                        >
                            {"BACK"}
                        </Button>
                        <Button
                            sx={{
                                justifyContent: "center",
                                borderRadius: 4,
                                minWidth: 156,
                                minHeight: 54,
                                background: "#112A63",
                                marginLeft: "20px",
                                "&:hover": {
                                    backgroundColor: "#112A63",
                                },
                            }}
                            variant="contained"
                            type="button"
                            onClick={(e) => navigate('/roleAssign')}
                        >
                            {"UPDATE"}
                        </Button>
                    </Box>
                </Box>
            </Card>
        </LayoutAccessManagement >
    );
};

export default RoleAssignModuleEdit;
